import React from 'react'
import { Outlet } from 'react-router-dom'

const Notification = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Notification
